import { Link } from 'react-router-dom';
import { LuArrowLeft } from 'react-icons/lu';
import './style.css';

const ProjectHero = ({ data, projectId, backTo = '/projects' }) => {
  if (!data) return null;
  const {
    backLabel = 'Назад к проектам',
    title,
    titleLines,
    description,
    descriptionLines,
  } = data;
  return (
    <section className="project-hero" data-project-id={projectId}>
      <Link to={backTo} className="project-hero__back">
        <LuArrowLeft />
        <span>{backLabel}</span>
      </Link>

      <div className="project-hero__content">
        <h1
          className={`project-hero__title${titleLines?.length ? ' project-hero__title--multiline' : ''}`}
        >
          {titleLines?.length
            ? titleLines.map((line) => (
                <span className="project-hero__title-line" key={line}>
                  {line}
                </span>
              ))
            : title}
        </h1>
        <p className={`project-hero__description${descriptionLines?.length ? ' project-hero__description--multiline' : ''}`}>
          {descriptionLines?.length
            ? descriptionLines.map((line) => (
                <span className="project-hero__description-line" key={line}>
                  {line}
                </span>
              ))
            : description}
        </p>
      </div>
    </section>
  );
};

export default ProjectHero;
